export enum AccountType {
  Freelancer = "freelancer",
  Client = "client",
}
